import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    never: translate({ id: 'recurrenceSettings.recurrenceEnd.option.never' }),
    afterNumber: translate({ id: 'recurrenceSettings.recurrenceEnd.option.afterNumber' }),
    onDate: translate({ id: 'recurrenceSettings.recurrenceEnd.option.onDate' }),
    label: translate({ id: 'recurrenceSettings.recurrenceEnd.dropdown.label' }),
  }))

  return api
}
